var _rect, _circle, _circle2, _path, _path2, _path3, _polygon, _rect2, _polygon2, _rect3, _ellipse, _ellipse2, _ellipse3, _ellipse4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLandscapeNature(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 400,
    viewBox: "0 0 800 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "sky",
    x1: "0%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#2D1B69",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#190A4E",
      stopOpacity: 1
    }
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 400,
    fill: "url(#sky)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 650,
    cy: 80,
    r: 40,
    fill: "#FFB02E",
    opacity: 0.8
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 650,
    cy: 80,
    r: 50,
    fill: "#FFB02E",
    opacity: 0.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 300 L200 150 L400 220 L600 180 L800 250 L800 400 L0 400 Z",
    fill: "#3D2B79",
    opacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 320 L150 200 L350 260 L550 220 L750 280 L800 400 L0 400 Z",
    fill: "#4D3B89",
    opacity: 0.7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 350 L100 250 L300 300 L500 260 L700 320 L800 400 L0 400 Z",
    fill: "#FFB02E",
    opacity: 0.6
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "100,320 120,280 140,320",
    fill: "#00D9FF",
    opacity: 0.4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 115,
    y: 320,
    width: 10,
    height: 30,
    fill: "#00D9FF",
    opacity: 0.3
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "650,300 680,250 710,300",
    fill: "#00D9FF",
    opacity: 0.4
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 673,
    y: 300,
    width: 14,
    height: 40,
    fill: "#00D9FF",
    opacity: 0.3
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 150,
    cy: 100,
    rx: 40,
    ry: 20,
    fill: "#FFFFFF",
    opacity: 0.2
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 180,
    cy: 100,
    rx: 35,
    ry: 18,
    fill: "#FFFFFF",
    opacity: 0.2
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 450,
    cy: 130,
    rx: 50,
    ry: 25,
    fill: "#FFFFFF",
    opacity: 0.15
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 490,
    cy: 130,
    rx: 40,
    ry: 20,
    fill: "#FFFFFF",
    opacity: 0.15
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandscapeNature);
export default __webpack_public_path__ + "static/media/landscape-nature.f0e69ae1ff94ee5e556c0269f224dd39.svg";
export { ForwardRef as ReactComponent };